import type { ExternalReleaseVersionType } from '../types';

export const VERSION_TYPE_LABELS: Record<ExternalReleaseVersionType, string> = {
  sop_ota: 'SOP/OTA版本',
  engineering: '工程版本',
  vas: 'VAS',
  poc: 'POC',
  customer_eval: '客户评测',
  mtour: 'Mtour',
  official: '正式版本',
};

/** BSP 前端可选项；official 仅用于历史数据与 RPA 展示，不允许重新选中 */
export const VERSION_TYPE_OPTIONS = [
  { value: 'sop_ota', label: VERSION_TYPE_LABELS.sop_ota },
  { value: 'engineering', label: VERSION_TYPE_LABELS.engineering },
  { value: 'vas', label: VERSION_TYPE_LABELS.vas },
  { value: 'poc', label: VERSION_TYPE_LABELS.poc },
  { value: 'customer_eval', label: VERSION_TYPE_LABELS.customer_eval },
  { value: 'mtour', label: VERSION_TYPE_LABELS.mtour },
];

export const versionTypeLabel = (value?: string | null): string =>
  (value && VERSION_TYPE_LABELS[value as ExternalReleaseVersionType]) || '-';
